import {GoogleAuthProvider, OAuthProvider, linkWithPopup, linkWithCredential} from 'firebase/auth';
import {registerPlugin} from '@capacitor/core';
import {FirebaseAuthentication} from '@capacitor-firebase/authentication';
import {firebaseAuth} from '../firebase';
import {getLoopAuthPlatform, resolveCurrentAuthProfile} from './socialAuth';

const credentialManager=registerPlugin('LoopCredentialManager');
let linking=false;
const requireSameUser=(user,uid)=>{
 if(!uid||!user||user.uid!==uid)throw new Error('account-link-session-changed');
 return user;
};
export async function readAccessMethods(uid){
 const user=getLoopAuthPlatform()==='ios'
  ?(await FirebaseAuthentication.getCurrentUser()).user:firebaseAuth.currentUser;
 return requireSameUser(user,uid).providerData.map(p=>p.providerId);
}
export async function linkAccessMethod(providerId,expectedUid){
 if(linking)throw new Error('account-link-in-progress');
 if(!['google.com','apple.com'].includes(providerId))throw new Error('account-link-provider-invalid');
 linking=true;
 try{
  const platform=getLoopAuthPlatform();let linkedUser;
  if(platform==='ios'){
   requireSameUser((await FirebaseAuthentication.getCurrentUser()).user,expectedUid);
   const result=providerId==='google.com'?await FirebaseAuthentication.linkWithGoogle():await FirebaseAuthentication.linkWithApple();
   linkedUser=result.user;
  }else{
   const user=requireSameUser(firebaseAuth.currentUser,expectedUid);
   if(platform==='android'){
    if(providerId!=='google.com')throw new Error('apple-login-not-enabled-on-android');
    // Request credentials only: never sign in as a different Firebase account.
    const result=await credentialManager.signInWithGoogle({serverClientId:'357961918175-otucm5e15jcpjo7p3ht5e7nblv12ago8.apps.googleusercontent.com',filterByAuthorizedAccounts:false});
    requireSameUser(firebaseAuth.currentUser,expectedUid);
    if(!result.idToken)throw new Error('account-link-missing-credential');
    linkedUser=(await linkWithCredential(user,GoogleAuthProvider.credential(result.idToken))).user;
   }else{
    const provider=providerId==='google.com'?new GoogleAuthProvider():new OAuthProvider('apple.com');
    if(providerId==='google.com')provider.setCustomParameters({prompt:'select_account'});
    else {provider.addScope('email');provider.addScope('name');}
    linkedUser=(await linkWithPopup(user,provider)).user;
   }
  }
  requireSameUser(linkedUser,expectedUid);
  // Linking succeeds independently of a temporary profile synchronization outage.
  let profileSynced=true;
  try{await resolveCurrentAuthProfile({forceRefresh:true,source:'profile_link_access'});}catch(_){profileSynced=false;}
  return {providerIds:await readAccessMethods(expectedUid),profileSynced};
 }finally{linking=false;}
}
export function accessMethodError(error){
 const code=String(error?.code||error?.message||'').toLowerCase();
 if(/credential-already-in-use|email-already-in-use/.test(code))return 'Este acceso ya pertenece a otra cuenta de Loop. No se han unido las cuentas ni movido tus reservas.';
 if(code.includes('provider-already-linked'))return 'Este método ya está vinculado a tu cuenta.';
 if(/popup-closed|cancelled|canceled/.test(code))return 'Vinculación cancelada.';
 if(/requires-recent-login|session-changed/.test(code))return 'Vuelve a iniciar sesión en esta cuenta antes de vincular otro acceso.';
 if(/unimplemented|not implemented|unavailable/.test(code))return 'Actualiza la app o vincula este acceso desde la web de Loop.';
 return 'No pudimos vincular este acceso. Tu método actual sigue disponible. Intenta nuevamente.';
}
